module.exports = __webpack_public_path__ + "static/media/wallet-cs.af320d98.png";